import { Link } from "react-router-dom";
import { specials } from "@/mocks/anime";

export default function Specials() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <p className="text-sm text-primary-600 font-medium inline-flex items-center gap-2">
              <i className="ri-magic-line"></i>
              专题聚合
            </p>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950">
              按主题一次看懂
            </h2>
          </div>
          <Link
            to="/about"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700"
          >
            更多专题 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {specials.map((s) => (
            <article
              key={s.id}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-accent-300 transition-all duration-300 hover:-translate-y-1 hover:shadow-card"
            >
              <div className="relative w-full h-48 overflow-hidden bg-background-100">
                <img
                  src={s.image}
                  alt={`${s.title} 专题图片`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-white text-xs">
                  {s.tag}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-medium text-foreground-950 group-hover:text-accent-600 transition-colors">
                    {s.title}
                  </h3>
                  <span className="text-xs text-accent-600 whitespace-nowrap">共 {s.count}</span>
                </div>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {s.desc}
                </p>
                <Link
                  to="/about"
                  className="mt-3 inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700"
                >
                  查看专题 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}